module.exports = __webpack_public_path__ + "static/media/empty-playlist-photo.1e0ba1bc.svg";